import type { CarrierPreferenceFormData, CarrierPreferencesData } from "../types/carrierPreferences"

import { CarrierType } from "@/graphql/codegen/graphql"

export const CARRIER_PREFERENCE_TYPE_LABELS = {
  [CarrierType.Standard]: "Standard",
  [CarrierType.Hazmat]: "Hazmat",
  [CarrierType.CarbonBlack]: "Carbon Black",
  [CarrierType.ThreePl]: "3PL",
  [CarrierType.Sample]: "Small Parcel",
} as const

export const CARRIER_PREFERENCE_TABS = [
  CarrierType.Standard,
  CarrierType.Hazmat,
  CarrierType.CarbonBlack,
  CarrierType.ThreePl,
  CarrierType.Sample,
]

export const EMPTY_CARRIER_PREFERENCE_FORM_DATA: CarrierPreferenceFormData = {
  carrierId: "",
  accountNumber: "",
  freightTerm: "",
  note: "",
  comment: "",
  customerPaysForSampleShipping: false,
}

export const DEFAULT_CARRIER_PREFERENCES_DATA: CarrierPreferencesData = {
  [CarrierType.Standard]: EMPTY_CARRIER_PREFERENCE_FORM_DATA,
  [CarrierType.Hazmat]: EMPTY_CARRIER_PREFERENCE_FORM_DATA,
  [CarrierType.CarbonBlack]: EMPTY_CARRIER_PREFERENCE_FORM_DATA,
  [CarrierType.ThreePl]: EMPTY_CARRIER_PREFERENCE_FORM_DATA,
  [CarrierType.Sample]: EMPTY_CARRIER_PREFERENCE_FORM_DATA,
}
